<div mat-dialog-title>
  <h2>
    Import
  </h2>
  <button type="button" class="close" mat-dialog-close aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<mat-dialog-content>
  <div class="mat-dialog-body">

    <div class="mat-dialog-inner">
      <h3 class="subhead-form">
        File
      </h3>
      <div class="fields-group">
        <app-file-manager [isRequired]="true" [managerIndex]="'updateAttachements'" [isSubmitted]="isSubmitted"
          [allowedExt]="['xls','xlsx']" [maxSize]="5" [label]="'Drag and Drop files here'" [files]="otherAttachments"
          [maxFiles]="maxFiles" (selectedFiles)="otherAttachments = $event">
        </app-file-manager>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between mt-4">
      <button mat-raised-button class="mat-outline primary mt-2" type="button" (click)="downloadFile()"
        [disabled]="downloadLoader" [class.loading]='downloadLoader'>
        Download Template
      </button>
      <div class="d-flex align-items-center justify-content-end">
        <button class=" mr-2 mt-2" mat-raised-button color="primary" [disabled]="loading || downloadLoader"
          [class.loading]='loading' (click)="saveRecord()">
          {{ 'forms.save' | translate }}
        </button>
        <button mat-raised-button mat-dialog-close color="grey" class=" mt-2" type="button"
          [disabled]="loading || downloadLoader">
          {{ 'swalMsg.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>